import GrowthOverviewComponent from '../Components/Growth/GrowthOverviewComponent';

function GrowthOverviewPage() {
  return <GrowthOverviewComponent />;
}

export default GrowthOverviewPage;